import { IDict } from "./types";

export const de: IDict = {
  Jobs: "Jobs",
  "No Jobs": "Keine Jobs",
  Billing: "Abrechnung",
  Credits: "Guthaben",
  "Pay Per Use": "Pay Per Use",
  "Feature Voting": "Funktionen abstimmen",
  "Free Karaoke Left": "Verbleibende kostenlose Karaoke",
  "Upgrade Now to Create More": "Jetzt upgraden, um mehr zu erstellen",
  "Storage is Full": "Speicher ist voll",
  "Youka is running out of storage space": "Youka geht der Speicherplatz aus",
  "Please free up at least 1 GB before creating new karaoke":
    "Bitte mindestens 1 GB freigeben, bevor Sie neues Karaoke erstellen",
  "Click the button to check again":
    "Klicken Sie auf die Schaltfläche, um erneut zu prüfen",
  "No Internet Connection": "Keine Internetverbindung",
  "Youka cannot connect to the internet":
    "Youka kann keine Verbindung zum Internet herstellen",
  "Please make sure you have internet connection":
    "Bitte stellen Sie sicher, dass Sie eine Internetverbindung haben",
  "Update is ready": "Update ist bereit",
  "Click the button to update":
    "Klicken Sie auf die Schaltfläche, um zu aktualisieren",
  "Library Folder": "Bibliotheksordner",
  "Export Folder": "Exportordner",
  "Sync Model": "Synchronisationsmodell",
  "Max Video Quality": "Maximale Videoqualität",
  "Speed / Compression Preset": "Geschwindigkeit / Kompressionsvoreinstellung",
  Change: "Ändern",
  "dialogs.upgrade.upgrade_to_pro":
    "Die von Ihnen gesuchte Funktion ist Teil des Pro-Plans. Führen Sie jetzt ein Upgrade durch, um diese Funktion freizuschalten.",
  "dialogs.upgrade.upgrade_to_standard":
    "Die von Ihnen gesuchte Funktion ist Teil des Standardplans. Führen Sie jetzt ein Upgrade durch, um diese Funktion freizuschalten.",
  heads_up: "Achtung!",
  "dialogs.edit_lyrics.not_supported": "Nicht unterstützt",
  "dialogs.create.title": "Neues Karaoke erstellen",
  "dialogs.create.description":
    "Bitte füllen Sie das untenstehende Formular aus, um ein neues Karaoke zu erstellen. Sie können eine Audio- oder Videodatei verwenden, Texte sind optional.",
  "dialogs.edit_lyrics.description":
    "Nach dem Speichern wird der Synchronisierungsvorgang gestartet. Sie können den Fortschritt im Reiter Jobs verfolgen",
  "dialogs.upgrade.see_plans": "Pläne ansehen",
  "dialogs.upgrade.unlock": "Freischalten",
  "comps.sync_editor.attach_previous": "An das vorherige Wort anhängen",
  "comps.sync_editor.attach_next": "An das nächste Wort anhängen",
  "comps.plans.title":
    "Wählen Sie den Plan, der am besten zu Ihren Bedürfnissen passt. Sie können jederzeit upgraden oder downgraden",
  "Font Size": "Schriftgröße",
  Spacing: "Abstand",
  Outline: "Umriss",
  "Margin Bottom": "Unterer Rand",
  "Max Chars per Line": "Max. Zeichen pro Zeile",
  Bold: "Fett",
  Italic: "Kursiv",
  Shadow: "Schatten",
  month: "Monat",
  songs: "Lieder",
  Title: "Titel",
  "Save and Sync": "Speichern und Synchronisieren",
  Lyrics: "Liedtexte",
  Update: "Aktualisieren",
  Playlist: "Wiedergabeliste",
  Canceling: "Abbrechen",
  Play: "Abspielen",
  "Lyrics Language": "Sprache der Liedtexte",
  "Background Image": "Hintergrundbild",
  "Basic Version": "Basisversion",
  "Standard Version": "Standardversion",
  "Pro Version": "Pro-Version",
  "Trial Version": "Testversion",
  "No Active Plan": "Kein aktiver Plan",
  "Days Left in Trial": "Verbleibende Tage der Testphase",
  Paste: "Einfügen",
  "Sync Lyrics": "Texte synchronisieren",
  Show: "Anzeigen",
  Settings: "Einstellungen",
  Retry: "Wiederholen",
  "Create Karaoke": "Karaoke erstellen",
  Canceled: "Abgebrochen",
  Reset: "Zurücksetzen",
  "Edit Video": "Video bearbeiten",
  Download: "Herunterladen",
  "Edit Metadata": "Metadaten bearbeiten",
  "Subtitle Designer": "Untertitel-Designer",
  Export: "Exportieren",
  year: "Jahr",
  Basic: "Basic",
  Standard: "Standard",
  Pro: "Pro",
  Accept: "Akzeptieren",
  "Add new word": "Neues Wort hinzufügen",
  "Add to queue": "Zur Warteschlange hinzufügen",
  "An unknown error occurred": "Ein unbekannter Fehler ist aufgetreten",
  Annually: "Jährlich",
  "Are you sure you want to delete this karaoke song?":
    "Sind Sie sicher, dass Sie dieses Karaoke-Lied löschen möchten?",
  "Artist Name": "Künstlername",
  "Audio or Video File": "Audio- oder Videodatei",
  Audio: "Audio",
  "Auto Karaoke Generator": "Auto-Karaoke-Generator",
  "Auto Lyrics Sync": "Automatische Liedtext-Synchronisation",
  "Cancel Plan": "Plan abbrechen",
  Cancel: "Abbrechen",
  Close: "Schließen",
  "Create Karaoke from song": "Karaoke aus Lied erstellen",
  "Create Karaoke from local files": "Karaoke aus lokalen Dateien erstellen",
  "Create new karaoke": "Neues Karaoke erstellen",
  Create: "Erstellen",
  "Current Plan": "Aktueller Plan",
  "Dark Mode": "Dunkler Modus",
  Decline: "Ablehnen",
  "Delete word": "Wort löschen",
  Delete: "Löschen",
  "Edit Lyrics": "Liedtexte bearbeiten",
  Edit: "Bearbeiten",
  "Export to mp3/mp4": "Als mp3/mp4 exportieren",
  "Go Back to EULA": "Zurück zur EULA",
  "Go back": "Zurück",
  "Go forward": "Vorwärts",
  Home: "Startseite",
  "I accept the terms and commit to avoiding unlicensed use of copyrighted content":
    "Ich akzeptiere die Bedingungen und verpflichte mich, die unerlaubte Nutzung urheberrechtlich geschützter Inhalte zu vermeiden",
  Instruments: "Instrumente",
  Library: "Bibliothek",
  "Light Mode": "Heller Modus",
  "Line Level Sync": "Zeilen-Level-Synchronisation",
  "Line Level": "Zeilen-Level",
  "Lyrics (optional)": "Liedtexte (optional)",
  "Lyrics Sync Editor": "Liedtext-Sync-Editor",
  Manage: "Verwalten",
  Monthly: "Monatlich",
  "Most popular": "Am beliebtesten",
  "No new notifications": "Keine neuen Benachrichtigungen",
  "No results": "Keine Ergebnisse",
  "No songs in library": "Keine Lieder in der Bibliothek",
  "No songs in queue": "Keine Lieder in der Warteschlange",
  Notifications: "Benachrichtigungen",
  Off: "Aus",
  Or: "Oder",
  "Plan canceled, will end in": "Plan abgebrochen, endet in",
  "Play word in loop": "Wort in Schleife abspielen",
  "Preparing Youka": "Youka vorbereiten",
  "Process 2 karaokes at a time": "2 Karaokes gleichzeitig verarbeiten",
  "Process 5 karaokes at a time": "5 Karaokes gleichzeitig verarbeiten",
  Queue: "Warteschlange",
  Ready: "Bereit",
  "Remove from queue": "Aus der Warteschlange entfernen",
  "Resume plan": "Plan fortsetzen",
  "Save and Resync": "Speichern und neu synchronisieren",
  Save: "Speichern",
  "Saving...": "Speichern...",
  Search: "Suchen",
  "Select plan": "Plan auswählen",
  "Sign In": "Anmelden",
  "Sign Out": "Abmelden",
  "Sign Up": "Registrieren",
  "Song Name": "Liedname",
  "Start typing to search or paste YouTube URL":
    "Zum Suchen tippen oder YouTube-URL einfügen",
  "Start typing to search": "Zum Suchen tippen",
  "Subtitle Track": "Untertitelspur",
  Subtitles: "Untertitel",
  Tempo: "Tempo",
  "Terms and Conditions": "Geschäftsbedingungen",
  "This action cannot be undone.":
    "Diese Aktion kann nicht rückgängig gemacht werden.",
  "Thumbnail URL": "Miniaturbild-URL",
  "To keep the karaoke fun going, please upgrade":
    "Um den Karaoke-Spaß fortzusetzen, bitte upgraden",
  "Unlock Premium Features with an Upgrade!":
    "Premium-Funktionen durch ein Upgrade freischalten!",
  "Update Payment Method": "Zahlungsmethode aktualisieren",
  "Upgrade to Pro plan to enable": "Auf Pro-Plan upgraden, um zu aktivieren",
  Upgrade: "Upgrade",
  Version: "Version",
  Video: "Video",
  Vocals: "Gesang",
  "Waiting in queue": "Warten in der Warteschlange",
  "Word Level Sync": "Wort-Level-Synchronisation",
  "Word Level": "Wort-Level",
  "You need to accept the EULA to use Youka":
    "Sie müssen die EULA akzeptieren, um Youka zu verwenden",
  "Your lyrics have been saved successfully. A resync is currently in progress. You can monitor the progress in the notification area. Once the resync is complete, you'll be able to see the changes - just hit 'play'.":
    "Ihre Liedtexte wurden erfolgreich gespeichert. Eine Neusynchronisation ist im Gange. Sie können den Fortschritt im Benachrichtigungsbereich überwachen. Sobald die Neusynchronisation abgeschlossen ist, können Sie die Änderungen sehen - einfach 'Abspielen' drücken.",
  "Your trial version of Youka has expired":
    "Ihre Testversion von Youka ist abgelaufen",
  "dialogs.youtube.title":
    "Installieren Sie das yt-dlp Plugin, um Online-Videos zu suchen und abzuspielen",
  "dialogs.youtube.description":
    "Bitte lesen und akzeptieren Sie die folgenden Warnungen, bevor Sie das Plugin aktivieren.",
  "dialogs.youtube.agree":
    "Ich habe die obigen Warnungen gelesen und verstanden",
  "dialogs.youtube.install": "Plugin installieren",
  "dialogs.youtube.install_success": "Plugin erfolgreich installiert",
  "dialogs.youtube.install_success_description":
    "Sie können jetzt Online-Videos suchen und abspielen",
  "dialogs.youtube.install_error": "Plugin-Installation fehlgeschlagen",
  "alert.youtube.description":
    "Das Plugin für Online-Video-Suche und -Download (yt-dlp) ist nicht vorinstalliert. Klicken Sie, um das Plugin zu installieren.",
  "alert.youtube.install": "Plugin installieren",
  "dialogs.settings.enable_youtube": "yt-dlp Plugin aktivieren",
  "dialogs.youtube.warnings": [
    {
      title: "Rechtliche Konformität",
      description:
        "Stellen Sie sicher, dass Ihre Nutzung dieses Plugins vollständig mit allen anwendbaren Gesetzen und den Nutzungsbedingungen aller Plattformen, mit denen Sie interagieren, wie YouTube, übereinstimmt.",
    },
    {
      title: "Urheberrecht und Lizenzierung",
      description:
        "Dieses Plugin kann Aktionen ermöglichen (wie das Herunterladen von Inhalten), die Urheberrechtsgesetze verletzen oder Lizenzvereinbarungen brechen könnten, wenn es nicht ordnungsgemäß verwendet wird. Es ist entscheidend, die Rechte der Inhaltschöpfer zu respektieren und das Plugin nur für gesetzlich zulässige Zwecke zu verwenden.",
    },
    {
      title: "Keine Billigung",
      description:
        "Die Aktivierung dieses Plugins impliziert keine Billigung oder Unterstützung durch unser Unternehmen. Das Plugin ist eine separate Entität, und wir sind nicht verantwortlich für seinen Betrieb oder die Folgen seiner Nutzung.",
    },
    {
      title: "Benutzerverantwortung",
      description:
        "Sie sind allein verantwortlich für alle Aktionen, die Sie mit diesem Plugin durchführen. Dies schließt jegliche rechtlichen Konsequenzen ein, die durch Missbrauch oder Verletzung der Nutzungsbedingungen entstehen können.",
    },
    {
      title: "Potenzielle Risiken",
      description:
        "Seien Sie sich bewusst, dass der Missbrauch des Plugins zur Kontosperrung oder rechtlichen Schritten von betroffenen Parteien oder Plattformen führen könnte.",
    },
    {
      title: "Informiertes Einverständnis",
      description:
        "Indem Sie fortfahren, dieses Plugin zu aktivieren, erkennen Sie an, dass Sie diese Warnungen gelesen und verstanden haben und die volle Verantwortung für die Nutzung des Plugins übernehmen.",
    },
  ],
  "model.auto": "Automatisch das beste Modell auswählen.",
  "model.audioshake.transcription":
    "Das erstbeste Modell, das das Transkribieren und anschließende Ausrichten umfasst, liefert bessere Ergebnisse, ist aber ausschließlich für Pay-per-Use- und Testbenutzer zugänglich (dauert bis zu 10 Minuten).",
  "model.audioshake":
    "Das zweitbeste Modell richtet sich nach den bereitgestellten Texten, wobei Ungenauigkeiten zu suboptimalen Ergebnissen führen können (dauert bis zu 10 Minuten).",
  "model.wav2vec2":
    "Das drittbeste Modell richtet sich nach den bereitgestellten Liedtexten, bei denen Ungenauigkeiten zu suboptimalen Ergebnissen führen können, und unterstützt fast alle Sprachen. (Dauert bis zu 30 Sekunden)",
  "model.whisper":
    "Das viertbeste Modell, das das Transkribieren und anschließende Ausrichten umfasst. Der ausgegebene Liedtext ist möglicherweise nicht genau, die Synchronisierung ist jedoch akzeptabel (dauert bis zu 2 Minuten).",
  "sync.line.instructions": [
    "Klicken Sie auf die Schaltfläche „Wiedergabe“, um das Lied abzuspielen und den Synchronisierungsvorgang zu starten",
    "Klicken Sie auf die Schaltfläche „Start festlegen“, wenn Sie das erste Wort der aktuellen Zeile hören.",
    "Klicken Sie auf die Schaltfläche „Ende festlegen“, nachdem Sie das letzte Wort der aktuellen Zeile gehört haben",
    "Fahren Sie fort, bis Sie mit der Synchronisierung aller Zeilen fertig sind",
  ],
  Undo: "Rückgängig machen",
  Redo: "Wiederholen",
  "Set Start": "Start festlegen",
  "Set End": "Ende festlegen",
  "dialogs.edit_lyrics.transcription":
    "Bei Verwendung des Transkriptionsmodells transkribiert das Modell das Lied selbstständig und identifiziert den Liedtext selbstständig, ohne sich auf bereitgestellte Liedtexte zu verlassen. Anschließend haben Sie die Möglichkeit, den Liedtext mit dem Synchronisierungstool anzupassen.",
  "Duet Editor": "Duet-Editor",
  "Manual Line Sync": "Manuelle Zeilen-Synchronisation",
  "New Style": "Neuer Stil",
  Style: "Stil",
  Singer: "Sänger",
  "Style Editor": "Stil-Editor",
  Word: "Wort",
  Line: "Zeile",
  "Split Line": "Zeile teilen",
  "Upgrade to Enable": "Upgrade, um zu aktivieren",
  upgrade_description:
    "Sie haben die Möglichkeit, die bereits erstellten Karaoke-Titel anzuhören oder herunterzuladen. Wenn Sie jedoch zusätzliche Karaoke-Tracks erstellen möchten, ist ein Upgrade erforderlich.",

  "dialogs.global.no_user.title": "No Active Plan",
  "dialogs.global.no_user.description": "Please upgrade to a plan to continue.",
  "dialogs.global.no_role.title": "No Active Plan",
  "dialogs.global.no_role.description": "Please upgrade to a plan to continue.",
  "dialogs.global.blocked_ip.title": "Your IP is blocked",
  "dialogs.global.blocked_ip.description": "Please contact support.",
  "dialogs.global.rate_limit.title": "Rate Limit Exceeded",
  "dialogs.global.rate_limit.description":
    "You may change your plan to unlimited Pay Per Use to continue",
  "dialogs.global.disk_full.title": "Lager ist voll",
  "dialogs.global.disk_full.description":
    "Bitte geben Sie etwas Speicherplatz frei, um Youka weiterhin nutzen zu können.",
  "dialogs.global.too_big.title":
    "Die Audiodatei überschreitet die Größenbeschränkung.",
  "dialogs.global.too_big.description":
    "Bitte beachten Sie, dass die Audiodatei eine maximale Dauer von 15 Minuten nicht überschreiten darf.",
  Help: "Hilfe",
  Original: "Original",
  Sort: "Sortieren",
  "sort.date.asc": "Date de création (du plus ancien au plus récent)",
  "sort.date.desc": "Date de création (du plus récent au plus ancien)",
  "sort.title.asc": "Titre (A à Z)",
  "sort.title.desc": "Titre (Z à A)",
  Start: "Start",
  End: "Ende",
  Time: "Zeit",
  "dialogs.trim.title": "Schneiden",
  "dialogs.trim.description":
    "Verwenden Sie den einstellbaren Rand auf der Wellenform, um den Teil des Liedes auszuwählen, den Sie behalten möchten.",
  Related: "Verwandte",
  preserve_vocals: "Stimmen erhalten",
  preserve_vocals_description:
    "Aktivieren Sie dies, um die Stimmen wie die Hintergrundstimmen zu erhalten.",
  "Separate Audio": "Audio trennen",
  "Separate Model": "Trennmodell",
  "Add Lyrics": "Text hinzufügen",
  "Background Image or Video": "Hintergrundbild oder -video",
  Docs: "Dokumente",
  Watch: "Ansehen",
  Hide: "Verbergen",
  "watch.sync.title":
    "Wie lässt sich die Synchronisierung von Liedtexten einfach reparieren?",
  "watch.sync.url": "https://www.youtube.com/watch?v=kEHzfAwQBzo",
  Review: "Bewerten",
  "watch.review.title": "Bewerten Sie Youka auf Trustpilot",
  "Import Subtitles": "Untertitel importieren",
  Import: "Importieren",
  "How to use": "Wie benutzt",
  Uppercase: "Großbuchstaben",
  "Open Dual Screen": "Doppelbildschirm öffnen",
  "Close Dual Screen": "Doppelbildschirm schließen",
  "Import Karaoke File": "Karaoke-Datei importieren",
  "dialogs.import_karaoke.title": "Karaoke aus Datei importieren",
  "dialogs.import_karaoke.description":
    "Importieren Sie ein Video oder Audiodatei und eine LRC-Datei, um ein Karaoke zu erstellen.",
  optional: "optional",
  "Trial Expired": "Testphase abgelaufen",
  "Subtitles Settings": "Untertitel-Einstellungen",
  Milliseconds: "Millisekunden",
  Seconds: "Sekunden",
  Text: "Text",
  Enabled: "Aktiviert",
  Duration: "Dauer",
  Gap: "Lücke",
  Offset: "Offset",
  "Min Duration": "Minimale Dauer",
  "Max Duration": "Maximale Dauer",
  "Fade In": "Fade In",
  "Fade Out": "Fade Out",
  "plugins.title.title": "Liedtitel",
  "plugins.title.description":
    "Fügen Sie den Liedtitel am Anfang des Videos ein",
  "plugins.gap_text.title": "Silent Gap Text",
  "plugins.gap_text.description":
    "Fügen Sie den Text in der Lücke zwischen den Untertiteln ein",
  "plugins.gap_progress_bar.title": "Silent Gap Progress Bar",
  "plugins.gap_progress_bar.description":
    "Fügen Sie eine Fortschrittsleiste in der Lücke zwischen den Untertiteln ein",
  "plugins.fade.title": "Fade-Effekt",
  "plugins.fade.description": "Fügen Sie Fade-Effekt zu Untertiteln hinzu",
  "plugins.offset.title": "Offset",
  "plugins.offset.description":
    "Verschieben Sie die Untertitel um eine bestimmte Anzahl von Sekunden",
  "plugins.countdown.title": "Countdown",
  "plugins.countdown.description":
    "Fügen Sie einen Countdown in die Lücke zwischen den Untertiteln ein",
  Auto: "Automatisch",
  Subword: "Teilwort",
  Countdown: "Countdown",
  "Restart required": "Neustart erforderlich",
  "Reindex Library": "Bibliothek neu indizieren",
  "Create playlist": "Playlist erstellen",
  "Are you sure you want to delete?":
    "Sind Sie sicher, dass Sie löschen möchten?",
  "Add to playlist": "Zur Playlist hinzufügen",
  "New playlist": "Neue Playlist",
  "Remove from this playlist": "Von dieser Playlist entfernen",
  Songs: "Songs",
  Playlists: "Playlists",
  Name: "Name",
  Photo: "Photo",
  "No playlists": "Keine Playlists",
  "Welcome to Youka": "Willkommen in Youka",
  "Search songs online": "Songs online suchen",
  "create.file.title": "Karaoke aus Datei erstellen",
  "create.file.description":
    "Lade deine MP3-, MP4- oder andere Dateien hoch, um sofort ein Karaoke-Video mit synchronisierten Texten zu erstellen.",
  "create.online.title": "Karaoke aus Online-Songs erstellen",
  "create.online.description":
    "Suche nach Songs online oder füge eine Song-URL ein, um sofort ein Karaoke-Video mit synchronisierten Texten zu erstellen.",
  "Change Background": "Hintergrund ändern",
  "Duet Line Split": "Duet-Zeilen-Trennung",
  Both: "Beide",
  Custom: "Benutzerdefiniert",
  Edited: "Bearbeitet",
  Trimmed: "Geschnitten",
  Instrumental: "Instrumental",
  "Add Subword": "Teilwort hinzufügen",
  "plugins.max_chars.title": "Maximale Zeichen pro Zeile",
  "plugins.max_chars.description": "Begrenze die Anzahl der Zeichen pro Zeile",
  Limit: "Limit",
  "Background Box": "Hintergrundbox",
  Height: "Höhe",
  Width: "Breite",
  Alpha: "Alpha",
  Color: "Farbe",
  Duplicate: "Duplizieren",
  "Convert to 16x9": "In 16x9 konvertieren",
  "Resize Video": "Video verkleinern",
  "Line Alignment": "Zeilenausrichtung",
  "Shadow Color": "Schattenfarbe",
  "Outline Color": "Umrandungsfarbe",
  "Active Color": "Aktive Farbe",
  "Secondary Color": "Sekundäre Farbe",
  "Primary Color": "Primäre Farbe",
  "Auto Alignment": "Automatische Ausrichtung",
  "Auto Color": "Automatische Farbe",
  "Singer 1": "Sänger 1",
  "Singer 2": "Sänger 2",
  "Top Row": "Obere Reihe",
  "Bottom Row": "Untere Reihe",
  "Border Style": "Rahmenstil",
  "Font Name": "Schriftart",
  "Experimental Subtitles Display": "Experimentelle Untertitel-Anzeige",
  Position: "Position",
  "Timing Indicator": "Zeitgeber",
  General: "Allgemein",
  Styles: "Stile",
  Thumbnail: "Thumbnail",
  "create.url.title": "Karaoke aus URL erstellen",
  "create.url.description":
    "Karaoke aus einer yt-dlp unterstützten URL erstellen",
  "Paste a URL or start typing to search":
    "URL einfügen oder beginnen Sie mit der Eingabe, um zu suchen",
  Top: "Oben",
  Bottom: "Unten",
  Center: "Mittig",
  "Auto Line Break": "Zeilen automatisch teilen",
  "Fill Color": "Füllfarbe",
  "Active Line Color": "Aktive Zeilenfarbe",
  "Waiting Line Color": "Wartende Zeilenfarbe",
  "Set as Default": "Als Standard festlegen",
  Default: "Standard",
  "Make Default": "Als Standard festlegen",
  Image: "Bild",
  Pause: "Pause",
  File: "Datei",
  "Debug Info": "Debug-Info",
  "File Type": "Dateityp",
  Language: "Sprache",
  "Reset Settings": "Einstellungen zurücksetzen",
  "Failed to start Youka": "Fehler beim Start von Youka",
  Legacy: "Traditionell",
  Transcription: "Transkription",
  Alignment: "Ausrichtung",
  Imported: "Importiert",
  "With Backing Vocals": "Mit Hintergrundstimmen",
  Stem: "Stem",
  Clear: "Löschen",
  "Open Directory": "Verzeichnis öffnen",
  "Advanced Settings": "Erweiterte Einstellungen",
  "How to Add a Background Black Box to Subtitles":
    "Wie man einen schwarzen Hintergrundkasten zu Untertiteln hinzufügt",
  "How to Adjust the Line Length": "Wie man die Zeilenlänge anpasst",
  "How to Cancel Your Subscription": "Wie man das Abonnement kündigt",
  "How to Center Subtitles": "Wie man Untertitel zentriert",
  "How to Delete a Karaoke": "Wie man ein Karaoke löscht",
  "How to Edit the lyrics": "Wie man den Liedtext bearbeitet",
  "How to Fix the Sync": "Wie man die Synchronisierung repariert",
  "How to Keep Choirs": "Wie man Chöre behält",
  "How to Keep the Original Singer’s Voice":
    "Wie man die Originalstimme des Sängers behält",
  "How to Set Up a Duet": "Wie man ein Duett einrichtet",
  "How to Speed Up the Download Process":
    "Wie man den Download-Prozess beschleunigt",
  "How to Transfer Your Karaoke Library to a New Computer":
    "Wie man die Karaoke-Bibliothek auf einen neuen Computer überträgt",
  "How to Trim a Karaoke Video": "Wie man ein Karaoke-Video schneidet",
  FAQ: "Häufige Fragen",
  "library.description":
    "Zugreifen und Verwalten aller Karaoke-Tracks, die Sie erstellt haben. Bearbeiten, organisieren und perfektionieren Sie Ihre Projekte.",
  "How to Change the Background Video": "Wie man das Hintergrundvideo ändert",
  "Auto Size": "Automatisch",
  "dialogs.global.no_credits.title": "Keine Credits verfügbar",
  "dialogs.global.no_credits.description":
    "Bitte laden Sie Guthaben auf, um fortzufahren",
  "Credits are over! Click to buy more":
    "Credits sind aufgebraucht! Klicken Sie, um mehr zu kaufen",
  "How to Add a Line Break": "Wie man einen neuen Zeilenumbruch hinzufügt",
  "dialogs.global.no_user.many_emails_description":
    "Der Zugriff wurde aufgrund mehrerer Anmeldungen mit verschiedenen E-Mail-Adressen blockiert. Bitte erwerben Sie ein Abonnement, um fortzufahren.",
  "dialogs.global.no_user.virtual_machine_description":
    "Der Zugriff wurde blockiert, weil Sie eine virtuelle Maschine verwenden. Um auf die kostenlose Testversion zuzugreifen, installieren Sie bitte Youka auf einem Standardbetriebssystem. Wenn Sie ein Abonnement haben, erneuern Sie dieses bitte, um den Zugriff wiederherzustellen. Wenn Sie keine fortlaufende Karaoke-Erstellung benötigen, können Sie einen Pay-per-Use-Plan wählen, sodass Sie nur dann zahlen, wenn Sie neuen Karaoke-Inhalt erstellen.",
  "Import Stem": "Stem importieren",
  "Active Outline Color": "Aktive Umrandungsfarbe",
  "Inactive Outline Color": "Inaktive Umrandungsfarbe",
  "Inactive Line Color": "Inaktive Zeilenfarbe",
  "Active Line": "Aktive Zeile",
  "Inactive Line": "Inaktive Zeile",
  "End Extra": "Ende Extra",
  Expand: "Erweitern",
  Collapse: "Zusammenziehen",
  "Copy Line": "Zeile kopieren",
  "Copy Word": "Wort kopieren",
  "Cut Line": "Zeile ausschneiden",
  "Cut Word": "Wort ausschneiden",
  "Delete Line": "Zeile löschen",
  "Delete Subword": "Teilwort löschen",
  "Delete Word": "Wort löschen",
  "Add Line": "Zeile hinzufügen",
  "Add Word": "Wort hinzufügen",
  "Paste Line": "Zeile einfügen",
  "Paste Word": "Wort einfügen",
  "Paste Subword": "Teilwort einfügen",
  "Play Line": "Zeile abspielen",
  "Play Word": "Wort abspielen",
  "Select Line": "Zeile auswählen",
  "Manual Sync": "Manuelle Synchronisation",
  "Trim Start": "Start schneiden",
  "Trim End": "Ende schneiden",
  "Creating will use 1 credit": "Das Erstellen wird 1 Guthaben verbrauchen",
  All: "Alle",
  "Number of Singers": "Anzahl der Sänger",
  "Style Mapping": "Stilzuordnung",
  "Associate subtitle styles with singers":
    "Untertitelstile mit Sängern verknüpfen",
  "Upper first line": "Obere erste Zeile",
  "Upper second line": "Obere zweite Zeile",
  "Lower first line": "Untere erste Zeile",
  "Lower second line": "Untere zweite Zeile",
  Lock: "Sperren",
  "2 Lines": "2 Zeilen",
  "4 Lines": "4 Zeilen",
  Static: "Statisch",
  Dynamic: "Dynamisch",
  "Subtitles Type": "Untertiteltyp",
  "Danger Zone": "Gefährliche Zone",
  Copy: "Kopieren",
  Copied: "Kopiert",
  "Copy Settings": "Einstellungen kopieren",
  "cta.social.title": "Erhalte 50 Credits GRATIS!",
  "cta.social.description":
    "Teile einen Beitrag über Youka in den sozialen Medien, markiere uns und verdiene 50 kostenlose Credits pro Plattform!",
  "cta.social.description.2":
    "Klicken Sie, um die Facebook-Seite von Youka zu besuchen, geben Sie ihr ein Like, teilen Sie einen Beitrag und senden Sie Ihre E-Mail im Chat, um 50 kostenlose Credits zu erhalten!",
  "Merge Line": "Zeilen zusammenfügen",
  Player: "Spieler",
  "Key Step": "Tonart-Schritt",
  "Tempo Step": "Tempo-Schritt",
  "Shift Line Forward": "Zeile nach vorne verschieben",
  "Shift Line Backward": "Zeile nach hinten verschieben",
  "create.description":
    "Erstelle Karaoke aus Audio- oder Videodateien (MP3, MP4 und mehr) oder füge eine URL ein, um sofort ein Karaoke-Video mit synchronisierten Liedtexten zu generieren.",
  "No file chosen": "Kein Datei ausgewählt",
  "Choose File": "Datei auswählen",
  "Watch Quick Start Video": "Quick Start Video ansehen",
  "Export Settings": "Einstellungen exportieren",
  "Import Settings": "Einstellungen importieren",
  "Video Guides": "Video-Anleitungen",
  "Quick Start Guide": "Schnellstart-Anleitung",
  "Lyrics Sync Guide": "Liedtextsynchronisation",
  Resolution: "Auflösung",
  "Subtitles Preset": "Untertitel-Voreinstellung",
  Preset: "Voreinstellung",
  Done: "Fertig",
  "New Style Mapping": "Neue Stilzuordnung",
  Horizontal: "Horizontal",
  Vertical: "Vertikal",
  Square: "Quadrat",
  New: "Neu",
  "New Subtitles Preset": "Neue Untertitel-Voreinstellung",
  "Change Aspect Ratio": "Seitenverhältnis ändern",
  "copyright.title.a": "Ich akzeptiere die",
  "copyright.title.b": "Musiknutzungsbestätigung",
  "copyright.description":
    "Durch Aktivieren dieses Kästchens bestätigen Sie, dass (A) Sie alle Rechte an der in diesem Video enthaltenen Musik besitzen; oder (B) die Musik gemeinfrei ist; oder (C) Sie die Erlaubnis aller erforderlichen Rechteinhaber haben, die Musik auf der Youka-Plattform zu verwenden.",
  "Add Intro Video": "Intro-Video hinzufügen",
  "dialogs.intro.description":
    "Fügen Sie ein benutzerdefiniertes Video zum Beginn des Karaoke hinzu",
  Transition: "Übergang",
  Fade: "Überblenden",
  "Circle Open": "Kreis öffnen",
  "Circle Close": "Kreis schließen",
  "Diagonal Open": "Diagonal öffnen",
  "Diagonal Close": "Diagonal schließen",
  "Smooth Left": "Weich nach links",
  "Smooth Right": "Weich nach rechts",
  Squares: "Quadrate",
  Dissolve: "Auflösen",
  Type: "Typ",
  "Song Title": "Liedtitel",
  Artists: "Sänger",
  Artist: "Sänger",
  "Parse Titles": "Liedtitel analysieren",
  "sort.artist.asc": "Sänger (A bis Z)",
  "sort.artist.desc": "Sänger (Z bis A)",
  "Title Style": "Liedtitel-Stil",
  "Artist Style": "Sänger-Stil",
  "Analyse Library": "Bibliothek analysieren",
  Key: "Tonart",
  "No Filter": "Keine Filter",
  "credits.message_one": "Dies wird {{count}} Guthaben verbrauchen",
  "credits.message_other": "Dies wird {{count}} Guthaben verbrauchen",
  "credits.badge_one": "{{count}} Guthaben",
  "credits.badge_other": "{{count}} Guthaben",
  "Provide song lyrics to save credits":
    "Liedtext hinzufügen, um Guthaben zu sparen",
  "Upload to Cloud Library": "In die Cloud-Bibliothek hochladen",
  "Cloud Library": "Cloud-Bibliothek",
  "Open Cloud Library": "Cloud-Bibliothek öffnen",
};
